import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/auth";
import { SUPPORTED_LANGUAGES, type LangCode } from "@/i18n";
import Landing from "./Landing";

export default function LandingLang() {
  const { pathname } = useLocation();
  const lang = pathname.replace(/^\//, "").split("/")[0] as LangCode;
  const { i18n } = useTranslation();
  const { user, loading } = useAuth();
  const isSupported = SUPPORTED_LANGUAGES.some((l) => l.code === lang);

  useEffect(() => {
    if (!isSupported) return;
    if (i18n.resolvedLanguage !== lang) {
      i18n.changeLanguage(lang);
    }
    localStorage.setItem("lang", lang);
  }, [lang, isSupported, i18n]);

  if (!isSupported) return <Navigate to="/" replace />;
  if (loading) return <div className="min-h-screen bg-background" aria-busy="true" />;
  if (user) return <Navigate to="/" replace />;
  return <Landing />;
}
